var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrowWhite = function SvgBackArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.10938L9.08997 7.51937L13.67 12.1094L9.08997 16.6994L10.5 18.1094L16.5 12.1094L10.5 6.10938Z",
    fill: "white"
  })));
};
export { SvgBackArrowWhite as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjUgNi4xMDkzOEw5LjA4OTk3IDcuNTE5MzdMMTMuNjcgMTIuMTA5NEw5LjA4OTk3IDE2LjY5OTRMMTAuNSAxOC4xMDk0TDE2LjUgMTIuMTA5NEwxMC41IDYuMTA5MzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";